import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("go2cardless_auth")
export class Go2CardlessAuthTable {

    @PrimaryGeneratedColumn({ name: "id" })
    id?: number;
    
    @Column() 
    username?: string;

    @Column()
    password?: string;
}